export const PAGE_WALKER_ZHCHS = {
    next: 'ä¸ä¸æ­¥',
    prev: 'ä¸ä¸æ­¥',
    skip: 'è·³è¿',
    startNow:'ç«å³ä½éª'
};
